// extracted by mini-css-extract-plugin
module.exports = {"nav":"Breadcrumbs_nav__RupH_"};